import { render } from "./AssignResourceGroupToTaskTable.vue?vue&type=template&id=4a5d27f3&scoped=true&ts=true"
import script from "./AssignResourceGroupToTaskTable.vue?vue&type=script&lang=ts"
export * from "./AssignResourceGroupToTaskTable.vue?vue&type=script&lang=ts"

import "./AssignResourceGroupToTaskTable.vue?vue&type=style&index=0&id=4a5d27f3&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5d27f3"]])

export default __exports__